// The template category a conversation template is stored and listed under.
export const chatTemplateCategory = 'chat_template'
